export const seeYouSoonOfferMinimumBrands = 4;
